import styled from "styled-components";
import axios from "axios";
import { useState } from "react";
import { baseURLStatic } from "../../services/authentication.js";
import Button from '@mui/material/Button';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';


const Container=styled.div`
	border: 1px solid grey;
	border-radius:8px;
	margin:25px;
	height:150px;
	display:flex;
	flex-direction:column;
	align-items:center;
	justify-content:space-between
 `;



export default function SubirVideo(){

	let [url,setUrl]=useState("url del video subido...");
	let [send,setSend]=useState(true)

	let sendVideo=async()=>{

		try{
			let video=document.getElementById("videoUp").files[0];
			console.log(document.getElementById("videoUp").files);
			const formVideo = new FormData();
			formVideo.append("video",video);
			const datoVideo=Object.fromEntries(formVideo.entries());
			console.log(datoVideo);
			let rpta= await axios.post(baseURLStatic+'/videos/',datoVideo,{headers: {"Content-Type": "multipart/form-data"} });
			setUrl(rpta.data);
			console.log(rpta.data);
		}catch(err){console.log(err);alert(err.message)}
	
	}


	return(
		<Container>
			<div>subir video</div>
			<input id="videoUp" type="file" disabled={send} />
			<Button variant="contained" loadingPosition="start" startIcon={<CloudUploadIcon />} loading={send} onClick={sendVideo} >subir</Button>
			<div><label>Ruta hacia el video en el servidor</label><input style={{width:"50vw"}} id="url" type="text"  disabled value={url}/></div>

		</Container>
		)
} 